export const onfidoBrandThemes = {
  frontnode: {
    name: 'light',
    config: {
      colorBackgroundSurfaceModal: '#ffffff',
      colorBorderSurfaceModal: '#ededed',
      colorContentButtonPrimaryText: '#ffffff',
      colorBackgroundButtonPrimary: '#3c44ff',
      colorBackgroundButtonPrimaryHover: '#6369ff',
      colorBackgroundButtonPrimaryActive: '#3c44ff',
      colorBorderButtonPrimary: '#3c44ff',
      colorBorderButtonPrimaryHover: '#6369ff',
      colorBorderButtonPrimaryActive: '#3c44ff',
      colorBorderButtonPrimaryFocus: '#3c44ff',
      colorContentButtonSecondaryText: '#3c44ff',
      colorBackgroundButtonSecondary: 'transparent',
      colorBackgroundButtonSecondaryHover: 'transparent',
      colorBackgroundButtonSecondaryActive: 'transparent',
      colorBorderButtonSecondary: '#3c44ff',
      colorBorderButtonSecondaryHover: '#6369ff',
      colorBorderButtonSecondaryActive: '#3c44ff',
      colorBorderButtonSecondaryFocus : '#3c44ff',
      borderRadiusButton: '12px',
      colorBorderDocTypeButtonHover: '#3c44ff',
      colorBorderDocTypeButtonActive: '#3c44ff',
    },
  },
  blockforia: {
    name: 'light',
    config: {
      colorBackgroundSurfaceModal: '#ffffff',
      colorBorderSurfaceModal: '#ededed',
      colorContentButtonPrimaryText: '#ffffff',
      colorBackgroundButtonPrimary: '#8338ec',
      colorBackgroundButtonPrimaryHover: '#6c18e1',
      colorBackgroundButtonPrimaryActive: '#8338ec',
      colorBorderButtonPrimary: '#8338ec',
      colorBorderButtonPrimaryHover: '#6c18e1',
      colorBorderButtonPrimaryActive: '#8338ec',
      colorBorderButtonPrimaryFocus: '#8338ec',
      colorContentButtonSecondaryText: '#8338ec',
      colorBackgroundButtonSecondary: 'transparent',
      colorBackgroundButtonSecondaryHover: 'transparent',
      colorBackgroundButtonSecondaryActive: 'transparent',
      colorBorderButtonSecondary: '#8338ec',
      colorBorderButtonSecondaryHover: '#6c18e1',
      colorBorderButtonSecondaryActive: '#8338ec',
      colorBorderButtonSecondaryFocus : '#8338ec',
      borderRadiusButton: '12px',
      colorBorderDocTypeButtonHover: '#8338ec',
      colorBorderDocTypeButtonActive: '#8338ec',
    },
  },
  omnidrive: {
    name: 'dark',
    config: {
      colorBackgroundSurfaceModal: '#1d1d1d',
      colorBorderSurfaceModal: '#ffffff1a',
      colorContentButtonPrimaryText: '#ffffff',
      colorBackgroundButtonPrimary: '#fd7d00',
      colorBackgroundButtonPrimaryHover: '#f90',
      colorBackgroundButtonPrimaryActive: '#fd7d00',
      colorBorderButtonPrimary: '#fd7d00',
      colorBorderButtonPrimaryHover: '#f90',
      colorBorderButtonPrimaryActive: '#fd7d00',
      colorBorderButtonPrimaryFocus: '#fd7d00',
      colorContentButtonSecondaryText: '#fd7d00',
      colorBackgroundButtonSecondary: 'transparent',
      colorBackgroundButtonSecondaryHover: 'transparent',
      colorBackgroundButtonSecondaryActive: 'transparent',
      colorBorderButtonSecondary: '#fd7d00',
      colorBorderButtonSecondaryHover: '#f90',
      colorBorderButtonSecondaryActive: '#fd7d00',
      colorBorderButtonSecondaryFocus : '#fd7d00',
      borderRadiusButton: '12px',
      colorBorderDocTypeButtonHover: '#fd7d00',
      colorBorderDocTypeButtonActive: '#fd7d00',
    },
  },
  payoro: {
    name: 'light',
    config: {
      colorBackgroundSurfaceModal: '#ffffff',
      colorBorderSurfaceModal: '#f1e8fb',
      colorContentButtonPrimaryText: '#ffffff',
      colorBackgroundButtonPrimary: '#732bb6',
      colorBackgroundButtonPrimaryHover: '#9747ff',
      colorBackgroundButtonPrimaryActive: '#732bb6',
      colorBorderButtonPrimary: '#732bb6',
      colorBorderButtonPrimaryHover: '#9747ff',
      colorBorderButtonPrimaryActive: '#732bb6',
      colorBorderButtonPrimaryFocus: '#732bb6',
      colorContentButtonSecondaryText: '#732bb6',
      colorBackgroundButtonSecondary: 'transparent',
      colorBackgroundButtonSecondaryHover: 'transparent',
      colorBackgroundButtonSecondaryActive: 'transparent',
      colorBorderButtonSecondary: '#732bb6',
      colorBorderButtonSecondaryHover: '#9747ff',
      colorBorderButtonSecondaryActive: '#732bb6',
      colorBorderButtonSecondaryFocus : '#732bb6',
      borderRadiusButton: '12px',
      colorBorderDocTypeButtonHover: '#732bb6',
      colorBorderDocTypeButtonActive: '#732bb6',
    },
  },
}
